import { SerializeHelper } from '../serialize-helper';

class ApiInput {
    constructor(data) {
        /** @type ?String */
        this.id = data?.id ?? null;

        /** @type ?String */
        this.type = data?.type ?? null;

        /** @type ?String */
        this.status = data?.status ?? null;

        /** @type ?String */
        this.source = data?.source ?? null;

        /** @type ?String */
        this.engine = data?.engine ?? null;

        /** @type Array */
        this.options = data?.options ?? [];

        /** @type ?String */
        this.filename = data?.filename ?? null;

        /** @type ?Number */
        this.size = SerializeHelper.getInteger(data?.size);

        /** @type ?String */
        this.hash = data?.hash ?? null;

        /** @type ?String */
        this.checksum = data?.checksum ?? null;

        /** @type ?String */
        this.contentType = data?.contentType ?? null;

        /** @type ?String */
        this.createdAt = data?.createdAt ?? null;

        /** @type ?String */
        this.modifiedAt = data?.modifiedAt ?? null;

        /** @type Array */
        this.credentials = data?.credentials ?? [];

        /** @type Array */
        this.parameters = data?.parameters ?? [];

        /** @type ?Object */
        this.metadata = data?.metadata ?? null;
    }

    /**
     * Called by JSON.stringify to get a representation as a serializable object
     *
     * @return {Object}
     */
    toJSON() {
        return {
            id: this.id,
            type: this.type,
            status: this.status,
            source: this.source,
            engine: this.engine,
            options: this.options,
            filename: this.filename,
            size: this.size,
            hash: this.hash,
            checksum: this.checksum,
            content_type: this.contentType,
            created_at: this.createdAt,
            modified_at: this.modifiedAt,
            credentials: this.credentials,
            parameters: this.parameters,
            metadata: this.metadata,
        };
    }
}

export { ApiInput };
